import { captureConsoleIntegration, extraErrorDataIntegration } from '@sentry/integrations'
import * as Sentry from '@sentry/vue'

const UNWANTED_ERROR_EVENTS_MESSAGES = ['Unauthorized', 'Bad credentials', 'The invitation has expired']

export default defineNuxtPlugin((nuxtApp) => {
  const {
    public: { GRAPHQL_ENDPOINT, sentry },
  } = useRuntimeConfig()

  if (import.meta.env.PROD && sentry?.dsn && sentry?.environment) {
    const router = useRouter()

    Sentry.init({
      app: nuxtApp.vueApp,
      dsn: sentry.dsn,
      environment: sentry.environment,
      beforeSend,
      integrations: [
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
          networkDetailAllowUrls: [GRAPHQL_ENDPOINT],
        }),
        Sentry.browserTracingIntegration({
          router,
        }),
        captureConsoleIntegration({
          levels: ['error'],
        }),
        extraErrorDataIntegration({
          depth: 5,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['https://app.kapital.inc', 'https://api-p.kapital.inc'],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    })

    function beforeSend(event) {
      if (event.level === 'error')
        return handleErrorFilter(event)

      return event
    }

    function handleErrorFilter(event) {
      const argument = event?.extra?.arguments?.length ? event.extra.arguments[0] : null
      if (argument && UNWANTED_ERROR_EVENTS_MESSAGES.some(msg => argument?.message?.includes(msg)))
        return null

      return event
    }
  }
})
